import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfBrush,
  PdfFont,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { OptsImage } from '../optsImage';
import { IItemCount } from '@educraft/base';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import { MM } from '../../modules/ui/controls/primitives';

/**
 * Pocitani_5 (Counting to 5) - Visual number representation with images
 *
 * Layout: 6 portrait pages, 3 equations per page.
 * Each equation row shows numbers as dot patterns using images
 * (like dice faces), with operators between them.
 *
 * Migrated from C# EduFrame.Img10.Generators.Pocitani_5
 */
export class Pocitani5 implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 10;
  }
  countMax(): number {
    return 10;
  }

  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const equations: string[] = [
      '1+1=2',
      '1+2=3',
      '1+3=4',
      '1+4=5',
      '1+1=2',
      '2+1=3',
      '3+1=4',
      '4+1=5',
      '2+2=4',
      '2+3=5',
      '3+2=5',
      '5−1=4',
      '5−2=3',
      '5−3=2',
      '5−4=1',
      '4−1=3',
      '3−1=2',
      '2−1=1',
    ];

    const count = 3;
    const numberPatterns: Record<number, number[][]> = {
      0: [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0],
      ],
      1: [
        [0, 0, 0],
        [0, 1, 0],
        [0, 0, 0],
      ],
      2: [
        [0, 0, 1],
        [0, 0, 0],
        [1, 0, 0],
      ],
      3: [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1],
      ],
      4: [
        [1, 0, 1],
        [0, 0, 0],
        [1, 0, 1],
      ],
      5: [
        [1, 0, 1],
        [0, 1, 0],
        [1, 0, 1],
      ],
    };

    const margin = PdfUnit.FromMillimeters(5);
    const bigFont = new PdfFont(PdfFont.FONT_NAME, 100);

    for (let pageIdx = 0; pageIdx < Math.ceil(equations.length / count); pageIdx++) {
      const page = pdf.addPage();
      const items = equations.slice(pageIdx * count, pageIdx * count + count);

      const rowSize = { width: PdfSize.A4.width, height: PdfSize.A4.height / items.length };

      for (let i = 0; i < items.length; i++) {
        const item = items[i].replace(/ /g, '');
        const rect = new PdfRect(0, i * rowSize.height, rowSize.width, rowSize.height);
        const sz = (rect.width - 2 * margin) / item.length;
        const cellSize = { width: sz, height: sz };
        const originY = rect.y + (rect.height - cellSize.height) / 2;
        const imageIndex = opts.data.random.next(0, Math.min(10, opts.list.length));

        for (let j = 0; j < item.length; j++) {
          const r = new PdfRect(
            margin + j * cellSize.width,
            originY,
            cellSize.width,
            cellSize.height
          );
          const ch = item[j];

          if (ch >= '0' && ch <= '9') {
            const num = parseInt(ch);
            const pattern = numberPatterns[num];
            if (pattern) {
              const dotSize = { width: r.width / 3, height: r.height / 3 };
              for (let dy = 0; dy < 3; dy++) {
                for (let dx = 0; dx < 3; dx++) {
                  if (pattern[dy][dx] > 0 && imageIndex < opts.list.length) {
                    const dr = new PdfRect(
                      r.x + dx * dotSize.width,
                      r.y + dy * dotSize.height,
                      dotSize.width,
                      dotSize.height
                    );
                    // page.drawRectangle(GUtil.basePen, null, dr);
                    const dr2 = dr.inflate(MM(2));
                    page.drawImageCenter(opts.list[imageIndex].image, dr2);
                  }
                }
              }
            }
          } else {
            page.drawString(ch, bigFont, PdfBrush.Black, null, r, ETextAlign.Center);
          }
        }

        page.drawRectangle(GUtil.cutPen, null, rect);
      }
    }
  }
}
